<app-slide-in-right-modal
  [slideOpen]="true"
  [returnPath]="returnPathUrl"
  (action)="closeModal()"
>
  <div class="pb-28">
    <!-- Header -->
    <div class="flex flex-col items-center text-center">
      <span class="text-xl font-bold text-mango-grey">
        Profile Photo
      </span>

      <img
        class="w-20 h-20 rounded-full mb-4 mt-6 object-cover border-2 border-gray-200"
        [src]="previewUrl || kycDetails?.userUploadedPhotoUrl || kycDetails?.passportPhotoUrl || '/assets/images/avatar-image.png'"
        alt="User Photo"
      />
      
      <!-- Show file name if selected -->
       @if (selectedFileName) {
      <p class="text-sm text-mango-grey mt-2">
        {{ selectedFileName }}
      </p>
      }
    </div>

    <!-- Actions -->
    <div class="mt-8 space-y-4">
      <button
        type="button"
        class="w-full py-3 rounded-lg text-white bg-mango font-semibold disabled:opacity-50 hover:brightness-95"
        (click)="fileInput.click()"
        [disabled]="isUploading"
      >
        {{ isUploading ? 'Uploading...' : 'Upload new photo' }}
      </button>

      <!-- Confirm button (only show when preview exists) -->
       @if (previewUrl && !isUploading) {
      <button
        type="button"
        class="w-full py-3 rounded-lg text-white bg-mango-pineGreen font-semibold hover:brightness-95"
        (click)="confirmUpload()"
      >
        Confirm Upload
      </button>
      }

      <p class="text-xs text-mango-gray74 text-center mt-4">
        Your BVN photo will be used if no custom photo is uploaded.
      </p>
      
      <!-- File requirements -->
      <p class="text-xs text-mango-gray74 text-center">
        Supported formats: JPG, PNG (Max 5MB)
      </p>
    </div>
  </div>

  <input
    #fileInput
    type="file"
    accept="image/jpeg,image/png,image/jpg"
    hidden
    (change)="onPhotoSelected($event)"
  />
</app-slide-in-right-modal>